import React from "react";
import { Phone, WhatsappLogo } from "@phosphor-icons/react";
import { COMPANY } from "../lib/constants";

const WHATSAPP_URL = `https://wa.me/33${COMPANY.phoneDigits.slice(1)}`;

export default function MobileCallBar() {
  return (
    <div
      data-testid="mobile-call-bar"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur-lg border-t border-slate-200 px-3 py-2.5 flex items-center gap-2 shadow-[0_-8px_30px_rgba(0,0,0,0.08)]"
    >
      <a
        href={COMPANY.phoneHref}
        data-testid="sticky-call-btn"
        className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-lg font-semibold text-sm btn-primary-eco"
      >
        <Phone size={18} weight="fill" /> Appeler
      </a>
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sticky-whatsapp-btn"
        className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-lg font-semibold text-sm btn-secondary-eco"
      >
        <WhatsappLogo size={18} weight="fill" /> WhatsApp
      </a>
    </div>
  );
}
